import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  fetchCategories, createCategory, updateCategory, deleteCategory,
  fetchManufacturers, createManufacturer, updateManufacturer, deleteManufacturer,
  fetchSites, fetchCustomers,
} from '@/services/settingsService';

export function useCategories() {
  return useQuery({
    queryKey: ['categories'],
    queryFn: fetchCategories,
    staleTime: 60_000,
  });
}

export function useCreateCategory() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: createCategory,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['categories'] }),
  });
}

export function useUpdateCategory() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, updates }: { id: string; updates: Parameters<typeof updateCategory>[1] }) =>
      updateCategory(id, updates),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['categories'] }),
  });
}

export function useDeleteCategory() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: deleteCategory,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['categories'] }),
  });
}

export function useManufacturers() {
  return useQuery({
    queryKey: ['manufacturers'],
    queryFn: fetchManufacturers,
    staleTime: 60_000,
  });
}

export function useCreateManufacturer() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: createManufacturer,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['manufacturers'] }),
  });
}

export function useUpdateManufacturer() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, updates }: { id: string; updates: Parameters<typeof updateManufacturer>[1] }) =>
      updateManufacturer(id, updates),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['manufacturers'] }),
  });
}

export function useDeleteManufacturer() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: deleteManufacturer,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['manufacturers'] }),
  });
}

export function useSites() {
  return useQuery({
    queryKey: ['sites'],
    queryFn: fetchSites,
    staleTime: 120_000,
  });
}

export function useCustomers() {
  return useQuery({
    queryKey: ['customers'],
    queryFn: fetchCustomers,
    staleTime: 60_000,
  });
}
